import React from 'react';

const ClassesHeaderSVG = (props) => (
    <svg width="100%" height="100%" viewBox="0 0 1316 58" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="1316" height="58" rx="20" fill={props.fill}/>
    </svg>

)

export default ClassesHeaderSVG;